import React from 'react';

const Icon: React.FC<React.HTMLAttributes<HTMLElement>> = (props) => <i aria-hidden="true" {...props} />;

export default Icon;